import axios from '@/libs/api.request'

/**
 * 筛选文件数据
 */
export const filterFileData = (folder, fileName, start_time, end_time) => {
    let data = {
        'folder': folder,
        'fileName': fileName,
        'start_time': start_time,
        'end_time': end_time
    }
    return axios.request({
        url: '/api/admin/messagelog/filterFileData',
        data,
        method: 'post'
    })
}

/**
 * 导出筛选文件数据
 */
 export const exportFileData = (folder, fileName, start_time, end_time) => {
    let data = {
        'folder': folder,
        'fileName': fileName,
        'start_time': start_time,
        'end_time': end_time
    }
    return axios.request({
        url: '/api/admin/messagelog/exportFileData',
        data,
        method: 'post'
    })
}

